import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Building2, ArrowLeft } from 'lucide-react';

const CGU = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Helmet>
        <title>Conditions Generales d'Utilisation | copropriete.app</title>
        <meta name="description" content="CGU de copropriete.app - Conditions d'utilisation du service de gestion de copropriete" />
      </Helmet>

      <header className="bg-white border-b border-slate-200 py-4 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold flex items-center gap-2 text-slate-900">
            <Building2 className="w-6 h-6 text-indigo-600" />
            copropriete.app
          </Link>
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-slate-900">
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Conditions Generales d'Utilisation</h1>
        
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8 text-slate-700 leading-relaxed">
          
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Preambule</h2>
            <p>Les presentes Conditions Generales d'Utilisation (ci-apres denommes "CGU") ont pour objet de definir les modalites et conditions d'utilisation des services proposes par la plateforme copropriete.app (ci-apres denomme "le Service"), ainsi que de definir les droits et obligations des parties dans ce cadre.</p>
            <p className="mt-2">Elles sont accessibles et imprimables a tout moment par un lien direct en bas de la page d'accueil du site.</p>
            <p className="mt-2">Toute inscription ou utilisation du Service implique l'acceptation sans aucune reserve ni restriction des presentes CGU par l'utilisateur.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 1 - Definitions</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>"Utilisateur"</strong> : designe toute personne physique ou morale qui accede au Service et l'utilise.</li>
              <li><strong>"Service"</strong> : designe l'ensemble des fonctionnalites proposees par copropriete.app, notamment la gestion des coproprietes, des assemblees generales, des appels de fonds et des documents.</li>
              <li><strong>"Copropriete"</strong> : designe l'ensemble immobilier dont la gestion est assuree via le Service.</li>
              <li><strong>"Compte"</strong> : designe l'espace personnel de l'Utilisateur lui permettant d'acceder au Service apres identification.</li>
              <li><strong>"Contenu"</strong> : designe l'ensemble des informations, donnees, textes, documents et fichiers publies par l'Utilisateur via le Service.</li>
              <li><strong>"Services Payants"</strong> : designe les services optionnels factures a l'acte, tels que l'envoi de lettres recommandees electroniques.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 2 - Objet</h2>
            <p>Les presentes CGU ont pour objet de definir les conditions dans lesquelles SAS SAS GMP Developpement met a disposition des Utilisateurs le Service copropriete.app, plateforme en ligne de gestion de copropriete destinee aux syndics benevoles et professionnels.</p>
            <p className="mt-2">Le Service permet notamment :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>La gestion des coproprietaires et de leurs tantiemes</li>
              <li>L'organisation et la tenue des assemblees generales</li>
              <li>La generation automatique des documents legaux (convocations, PV, etc.)</li>
              <li>La gestion des appels de fonds et le suivi des paiements</li>
              <li>Le stockage et le partage securise des documents</li>
              <li>La comptabilite simplifiee de la copropriete</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 3 - Acces au Service</h2>
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">3.1 Conditions d'acces</h3>
            <p>Le Service est accessible a toute personne physique agee de 18 ans ou plus, disposant de la pleine capacite juridique pour s'engager au titre des presentes CGU. L'Utilisateur mineur doit obtenir l'autorisation de son representant legal.</p>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">3.2 Creation de compte</h3>
            <p>L'acces au Service necessite la creation d'un Compte. L'Utilisateur s'engage a fournir des informations exactes, completes et a jour lors de son inscription, et a les maintenir a jour.</p>
            <p className="mt-2">L'Utilisateur est seul responsable de la preservation de la confidentialite de ses identifiants de connexion. Toute utilisation du Service effectuee a partir de son Compte sera reputee avoir ete effectuee par lui.</p>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">3.3 Gratuite du Service</h3>
            <p>Le Service de base est entierement gratuit et le restera. L'ensemble des fonctionnalites de gestion de copropriete (copropriétaires, assemblees generales, appels de fonds, documents, comptabilite, assistant juridique) sont accessibles sans frais et sans limitation.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 4 - Services payants a l'acte</h2>
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">4.1 Services optionnels</h3>
            <p>Certains services complementaires sont proposes a l'acte et factures unitairement :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Envoi de lettres recommandees electroniques (Clearbus)</strong> : 8,90 € TTC par envoi, utilise notamment pour les mises en demeure et convocations d'AG</li>
              <li><strong>Etat date</strong> : service de generation d'etat date lors des ventes de lots (tarif indique lors de la commande)</li>
            </ul>
            <p className="mt-2">Ces services sont entierement optionnels et ne conditionnent pas l'acces aux fonctionnalites de base du Service.</p>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">4.2 Paiement</h3>
            <p>Le paiement des Services Payants s'effectue par carte bancaire via notre prestataire de paiement securise Stripe. Le paiement est exigible au moment de la commande.</p>
            <p className="mt-2">Une facture est envoyee par email a l'Utilisateur apres chaque paiement.</p>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">4.3 Droit de retractation</h3>
            <p>Conformement a l'article L.221-28 du Code de la consommation, le droit de retractation ne peut etre exerce pour les services pleinement executes avant la fin du delai de retractation (envoi de courrier recommande) et dont l'execution a commence apres accord prealable expres du consommateur.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 5 - Obligations de l'Utilisateur</h2>
            <p>L'Utilisateur s'engage a :</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Utiliser le Service conformement a sa destination et aux presentes CGU</li>
              <li>Ne pas utiliser le Service a des fins illegales, frauduleuses ou portant atteinte aux droits de tiers</li>
              <li>Ne pas tenter de porter atteinte au bon fonctionnement du Service</li>
              <li>Garantir l'exactitude et la legalite des informations et documents qu'il communique via le Service</li>
              <li>Respecter les droits de propriete intellectuelle de SAS GMP Developpement et des tiers</li>
              <li>Ne pas collecter ou tenter de collecter des informations concernant les autres Utilisateurs</li>
              <li>Informer immediatement SAS GMP Developpement de toute utilisation non autorisee de son Compte</li>
              <li>Conserver la confidentialite de ses identifiants et ne pas les communiquer a des tiers non autorises</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 6 - Donnees et contenus</h2>
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">6.1 Propriete des donnees</h3>
            <p>L'Utilisateur reste proprietaire de l'ensemble des donnees et documents qu'il saisit ou televerse sur le Service. SAS GMP Developpement n'acquiert aucun droit de propriete sur ces contenus.</p>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">6.2 Licence d'utilisation</h3>
            <p>L'Utilisateur accorde a SAS GMP Developpement une licence non exclusive, mondiale et gratuite d'utilisation de ses contenus aux seules fins de fourniture du Service (stockage, affichage, transmission aux autres Utilisateurs autorises de la copropriete).</p>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">6.3 Sauvegarde et portabilite</h3>
            <p>SAS GMP Developpement effectue des sauvegardes regulieres des donnees. Toutefois, l'Utilisateur est invite a conserver ses propres sauvegardes des documents importants.</p>
            <p className="mt-2">L'Utilisateur peut a tout moment exporter ses donnees dans un format standard (PDF, CSV) depuis son espace personnel.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 7 - Responsabilite</h2>
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">7.1 Responsabilite de SAS GMP Developpement</h3>
            <p>SAS GMP Developpement s'engage a mettre en oeuvre tous les moyens raisonnables pour assurer la disponibilite et la securite du Service. Toutefois, SAS GMP Developpement ne saurait etre tenue responsable :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Des dommages indirects, accessoires ou consecutifs</li>
              <li>Des pertes de donnees resultant d'une defaillance de l'Utilisateur</li>
              <li>De l'utilisation faite par l'Utilisateur du Service ou des resultats obtenus</li>
              <li>Des interruptions temporaires du Service pour maintenance</li>
              <li>Des decisions prises par l'Utilisateur sur la base des informations fournies par le Service</li>
            </ul>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">7.2 Responsabilite de l'Utilisateur</h3>
            <p>L'Utilisateur est seul responsable de l'utilisation qu'il fait du Service et des contenus qu'il y publie. Il garantit SAS GMP Developpement contre toute reclamation de tiers resultant de son utilisation du Service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 8 - Propriete intellectuelle</h2>
            <p>Le Service, incluant notamment son architecture, sa charte graphique, ses textes, images, logos et logiciels, est la propriete exclusive de SAS GMP Developpement ou fait l'objet d'une licence d'utilisation.</p>
            <p className="mt-2">L'Utilisateur s'interdit toute reproduction, representation, modification ou exploitation de tout ou partie du Service sans l'autorisation prealable et ecrite de SAS GMP Developpement.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 9 - Suppression de compte</h2>
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">9.1 Suppression par l'Utilisateur</h3>
            <p>L'Utilisateur peut supprimer son compte a tout moment depuis son espace personnel ou en contactant le support a gmpdeveloppement@gmail.com. La suppression est effective immediatement.</p>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">9.2 Suspension par SAS GMP Developpement</h3>
            <p>SAS GMP Developpement se reserve le droit de suspendre ou supprimer le Compte d'un Utilisateur en cas de :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Non-respect des presentes CGU</li>
              <li>Utilisation frauduleuse du Service</li>
              <li>Non-paiement des Services Payants commandes</li>
              <li>Comportement portant atteinte aux interets de SAS GMP Developpement ou d'autres Utilisateurs</li>
            </ul>
            
            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">9.3 Effets de la suppression</h3>
            <p>A la suite de la suppression, l'Utilisateur conserve l'acces a ses donnees pendant une periode de trente (30) jours pour permettre leur exportation. Passe ce delai, les donnees pourront etre supprimees definitivement.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 10 - Protection des donnees personnelles</h2>
            <p>SAS GMP Developpement s'engage a proteger les donnees personnelles des Utilisateurs conformement au Reglement General sur la Protection des Donnees (RGPD) et a la loi Informatique et Libertes.</p>
            <p className="mt-2">Pour plus d'informations sur le traitement des donnees personnelles, veuillez consulter notre <Link to="/politique-confidentialite" className="text-indigo-600 hover:underline">Politique de Confidentialite</Link>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 11 - Modification des CGU</h2>
            <p>SAS GMP Developpement se reserve le droit de modifier les presentes CGU a tout moment. Les Utilisateurs seront informes de toute modification substantielle par email et/ou par notification sur le Service.</p>
            <p className="mt-2">La poursuite de l'utilisation du Service apres notification des modifications vaut acceptation des nouvelles CGU.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 12 - Droit applicable et juridiction</h2>
            <p>Les presentes CGU sont regies par le droit francais.</p>
            <p className="mt-2">En cas de litige relatif a l'interpretation ou a l'execution des presentes CGU, les parties s'efforceront de trouver une solution amiable. A defaut d'accord amiable, le litige sera soumis aux tribunaux competents de Chambery.</p>
            <p className="mt-2">Conformement aux dispositions du Code de la consommation concernant le reglement amiable des litiges, l'Utilisateur peut recourir au service de mediation propose par SAS GMP Developpement. Le mediateur peut etre saisi via : <a href="mailto:gmpdeveloppement@gmail.com" className="text-indigo-600 hover:underline">gmpdeveloppement@gmail.com</a>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 13 - Dispositions diverses</h2>
            <p>Si l'une quelconque des dispositions des presentes CGU etait declaree nulle ou inapplicable, les autres dispositions resteraient en vigueur.</p>
            <p className="mt-2">Le fait pour SAS GMP Developpement de ne pas se prevaloir d'un manquement de l'Utilisateur a l'une quelconque des obligations visees aux presentes ne saurait etre interprete comme une renonciation a l'obligation en cause.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 14 - Contact</h2>
            <p>Pour toute question relative aux presentes CGU, l'Utilisateur peut contacter SAS GMP Developpement :</p>
            <div className="bg-slate-50 p-4 rounded-lg mt-2">
              <p>Email : <a href="mailto:gmpdeveloppement@gmail.com" className="text-indigo-600 hover:underline">gmpdeveloppement@gmail.com</a></p>
              <p>Adresse : 51 Rue Michel Jandet, 73390 Chamoux-sur-Gelon, France</p>
            </div>
          </section>

          <div className="pt-6 border-t border-slate-200 text-sm text-slate-500">
            <p>Derniere mise a jour : Mars 2026</p>
          </div>
        </div>
      </main>

      <footer className="bg-slate-900 text-slate-400 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm">2026 SAS GMP Developpement - copropriete.app</p>
        </div>
      </footer>
    </div>
  );
};

export default CGU;
